module.exports = __webpack_public_path__ + "static/media/chat.dd989786.png";